import React, { useEffect, useRef, useState } from "react";
import { Slate, Editable, withReact } from "slate-react";
import { createEditor, Transforms } from "slate";
import EmojiPicker from "emoji-picker-react";
import { BiWorld } from "react-icons/bi";
import { FaUserGroup } from "react-icons/fa6";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import { Autocomplete, TextField, Chip, Box } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Cookies from "js-cookie";
import axios from "axios";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../pages/User/cropUtils";
import { getCroppedProfileImg } from "../pages/User/CropUtilss";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../Components/BaseUrl";
import { FaCamera } from "react-icons/fa";
import { IoIosAddCircleOutline } from "react-icons/io";
import { TfiPencil } from "react-icons/tfi";
import { MdOutlineEdit } from "react-icons/md";
import swal from "sweetalert2";
const EditGroupModal = ({ modalOpen, closeModal,groupData,onGroupCreated }) => {
  const profile = useRef(null);
  const bg_profile = useRef(null);
  const [inputKey, setInputKey] = useState(Date.now());
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [image, setImage] = useState(null);
  const [pimage, setPImage] = useState(null);
  const [fimage, setFImage] = useState(null);
  const [fpimage, setFPImage] = useState(null);
  const [bgpreview, setBgPreview] = useState(null);
  const [preview, setPreview] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedbgImage, setSelectedBgImage] = useState(null);

  const [industries, setIndustries] = useState([]);

  const [formData, setFormData] = useState({
    id:"",
    slug:"",
    group_name: "",
    description: "",
    industry: [],
    location: "",
    rules: "",
    allow_invite:"",
    admin_approve:"",
    discoverability:"",
    group_type:"",
    image:"",
    cover_image:""
  });
  const [error, setError] = useState({
    group_name: "",
    description: "",
  });

  const [isModalBgProfile, setIsModalBgProfile] = useState(false);
  const [isModalProfile, setIsModalProfile] = useState(false);
  useEffect(() => {
    getIndustry();
  }, []);
  useEffect(() => {
    if (groupData) {
      setFormData({
        id: groupData.id,
        slug: groupData.slug ,
        group_name: groupData.group_name ,
        description: groupData.description ,
        industry: groupData.industry_id ,
        location: groupData.location ,
        rules: groupData.rules || "" ,
        allow_invite: groupData.allow_invite ,
        admin_approve: groupData.admin_approve ,
        discoverability: groupData.discoverability ,
        group_type: groupData.group_type  ,
        image: groupData.image ,
        cover_image: groupData.cover_image ,
      });
      console.log(formData,"dfhdfdf")
    }
  }, [groupData]);
  const getIndustry = async () => {
    try {
      const response = await axios.get(BaseUrl + "getindustries", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setIndustries(response.data.data);
    } catch (error) {
      console.error("Error fetching industries:", error);
    }
  };

  const openModalBgProfile = () => {
    setIsModalBgProfile(true);
  };
  const closeModalBgProfile = () => {
    setIsModalBgProfile(false);
    setBgPreview(null);
  };

  const openModalProfile = () => {
    setIsModalProfile(true);
  };
  const closeModalProfile = () => {
    setIsModalProfile(false);
    setPreview(null);
    
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#0B6623",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "16px",
    width: "100%",
    padding: "8px 8px",
    border: "5px solid #ccc",

    transition: "all 0.3s ease-in-out",
    backgroundColor: "#fff",
    cursor: "pointer",

    "input:hover ~ &": {
      border: "5px solid rgb(117, 126, 119)",
    },

    "input:checked ~ &": {
      border: "5px solid #0B6623",
      backgroundColor: "#E8F0FE",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    // border: "2px solid #0B6623",
    boxShadow: "inset 0 0 0 2px #0B6623",
    backgroundColor: "#E8F0FE",
  });

  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
        sx={{ display: "flex", alignItems: "start", justifyContent: "start" }}
      />
    );
  }

  const handleradiochange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      group_type: value,
    }));
    if(value === "Public"){
      setFormData((prevData) => ({
        ...prevData,
        discoverability: "",
      }));
    }
    if(value === "Private"){
      setFormData((prevData) => ({
        ...prevData,
        discoverability: "Listed",
      }));
    }
  };
  const handleLocationChange = (event, newValue) => {
    if (newValue.length <= 3) {
      setFormData((prev) => ({
        ...prev,
        industry: newValue,
      }));
    }
  };
  const handleCheckboxChange = (permission) => {
    const allowedPermissions = ["allow_invite", "admin_approve"];

    if (!allowedPermissions.includes(permission)) {
      console.error("Invalid permission");
      return;
    }
    setFormData((prevData) => {
      return {
        ...prevData,
        [permission]: prevData[permission] === true ? false : true,
      };
    });
  };

  const handlegroupChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setError({ ...error, [name]: "" });
    const isFormValid =
      formData.group_name.trim() !== "" && formData.description.trim() !== "";
    setIsButtonDisabled(!isFormValid);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  }, []);
  const saveCroppedImage = async (e) => {
    e.preventDefault();
    if (!image) return;
    const croppedImage = await getCroppedImg(image, croppedArea);
    setBgPreview(croppedImage);
    setFImage(croppedImage);
    setImage(null);
  };
  const handleBgImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        swal.fire(
          "Invalid File",
          "Only JPG, PNG, and WEBP are allowed.",
          "error"
        );
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        swal.fire("File Too Large", "Image should be under 2MB.", "error");
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const minWidth = 800; 
        const minHeight = 350; 
        const maxWidth = 1920; 
        const maxHeight = 1200; 

        if (img.width < minWidth || img.height < minHeight) {
          swal.fire(
            "Image Too Small",
            `Minimum size required: ${minWidth}x${minHeight}px.`,
            "error"
          );
          return;
        }

        if (img.width > maxWidth || img.height > maxHeight) {
          swal.fire(
            "Image Too Large",
            `Maximum allowed size: ${maxWidth}x${maxHeight}px.`,
            "error"
          );
          return;
        }

        setSelectedBgImage(file);
        setImage(img.src);
        setBgPreview(null);
        setFormData((prev) => ({
          ...prev,
          cover_image: file,
        }));
      };
    }
  };


  const onCropProfileComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
    },
    []
  );
  const saveCroppedProfileImage = async (e) => {
    e.preventDefault();
    if (!pimage) return;
    const croppedImage = await getCroppedProfileImg(pimage, croppedArea);
    setPreview(croppedImage);
    setFPImage(croppedImage);
    setPImage(null);
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
    if (!validTypes.includes(file.type)) {
      swal.fire({
        icon: "error",
        title: "Invalid File Type",
        text: "Only JPG, PNG, WEBP, and GIF files are allowed.",
      });
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      swal.fire({
        icon: "warning",
        title: "File Too Large",
        text: "File size should be less than 2MB.",
      });
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const minWidth = 300;
      const minHeight = 300;
      const maxWidth = 3000;
      const maxHeight = 3000;

      if (img.width < minWidth || img.height < minHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Small",
          text: `Minimum dimensions required: ${minWidth}x${minHeight}px.`,
        });
        return;
      }

      if (img.width > maxWidth || img.height > maxHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Large",
          text: `Maximum allowed dimensions: ${maxWidth}x${maxHeight}px.`,
        });
        return;
      }

      setSelectedImage(file);
      setPImage(img.src);
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));
    };
  };
  const handleeditgroup = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
  
    Object.keys(formData).forEach((key) => {
      if (key === "image" || key === "cover_image") {
        return; 
      }
  
      if (key === "industry") {
        formDataToSend.append(key, formData.industry.map((industry) => industry.id).join(","));
      } else if (key === "discoverability") {
        formDataToSend.append(key, formData[key] ?? ""); 
      } else if (key === "allow_invite" || key === "admin_approve") {
        const intValue = formData[key] === true || formData[key] === "true" ? 1 : 0;
        formDataToSend.append(key, intValue);
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });
  
    if (selectedImage) {
      formDataToSend.append("image", selectedImage);
    }
    if (selectedbgImage) {
      formDataToSend.append("cover_image", selectedbgImage);
    }
  
    console.log("Form Data Sent:", [...formDataToSend.entries()]);
  
    const token = Cookies.get("token");
  
    try {
      const response = await axios.post(
        BaseUrl + `editgroup/${formData.slug}`,
        formDataToSend,
        {
          headers: {
           
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status === 200) {
        swal.fire({
          icon: "success",
          title: "Group Updated Successfully",
          text: "You have successfully updated your group",
        });
        if (onGroupCreated) {
          onGroupCreated(groupData.slug); 
        }
        closeModal();
      }
    } catch (error) {
      console.error("Error updating group:", error);
    }
  };
  
  

  const ApplyBgImage = (e) => {
    e.preventDefault();
    closeModalBgProfile();
  };
  const ApplyImage=(e)=>{
    e.preventDefault();
    closeModalProfile();
  }
  
  return (
    <>
      {modalOpen && (
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="modal-dialog bg-white  rounded-[30px] shadow-lg max-w-2xl w-full border-8 border-gray-500"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content border-[#F16163] ">
              <div className="modal-header bg-white  flex justify-between items-center rounded-t-[30px] px-4 py-1 border-b">
                <div className="flex items-start rounded-lg hover:bg-gray-200 p-2">
                  <p className="text-2xl font-semibold"> Edit group </p>
                </div>
                <button
                  type="button"
                  className="text-gray-500"
                  onClick={closeModal}
                >
                  ✖
                </button>
              </div>

              <div className="modal-body py-4  overflow-y-auto max-h-[500px]">
                <div className="relative">
                  <div className="absolute top-5 right-5 bg-white rounded-full ">
                    <button
                      className="text-xl text-gray-500 hover:text-gray-600 rounded-full border border-gray-500 p-2"
                      onClick={openModalBgProfile}
                    >
                      <MdOutlineEdit />
                    </button>
                  </div>
                  {isModalBgProfile && (
                    <div className="fixed inset-0 bg-gray-800  bg-opacity-50 flex items-center justify-center z-10">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                          <h2 className="text-xl font-semibold">
                            Edit background photo
                          </h2>
                          <button
                            onClick={closeModalBgProfile}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="px-5 py-4">
                          <form className="space-y-4">
                            <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
                              <input
                                key={inputKey}
                                type="file"
                                accept="image/*"
                                onChange={handleBgImageChange}
                                className="absolute w-full h-full opacity-0 cursor-pointer"
                              />
                              {image && (
                                <div className="relative w-full h-96 bg-black">
                                  <Cropper
                                    image={image}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={4 / 1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                  />
                                  <button
                                    onClick={saveCroppedImage}
                                    className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
                                  >
                                    Save Cropped Image
                                  </button>
                                </div>
                              )}
                              {bgpreview ? (
                                <div className="flex flex-col items-center">
                                  <img
                                    src={bgpreview}
                                    alt="Preview"
                                    className="mt-2 rounded-xl shadow-md border"
                                  />
                                </div>
                              ) : !image ? (
                                <>
                                  <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
                                    <FaCamera />
                                  </div>

                                  <span className="text-gray-500">
                                    Upload a photo
                                  </span>
                                </>
                              ) : null}
                            </div>
                            <button
                              onClick={ApplyBgImage}
                              className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
                            >
                              Apply Image
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                  <img
                    src={
                      fimage ||
                      (formData.cover_image
                        ? formData.cover_image
                        : "/Images/cover-img.jpg")
                    }
                    alt="Creative design background"
                    className="w-full h-56 object-cover "
                  />
                  <div className="absolute bottom-8 left-4 transform translate-y-1/2">
                    <img
                      src={
                        fpimage ||
                        (formData.image
                          ? formData.image
                          : "/Images/user-img.jpg")
                      }
                      alt="Profile of Erikson George"
                      className="size-32  border-4 border-white"
                    />
                    <button
                      className="absolute bottom-[-10px] left-[106px] text-xl text-gray-500 hover:text-gray-600 rounded-full border border-gray-500 p-2"
                      onClick={openModalProfile}
                    >
                      <MdOutlineEdit />
                    </button>
                  </div>
                  {isModalProfile && (
                    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                          <h2 className="text-xl font-semibold">Add photo</h2>
                          <button
                            onClick={closeModalProfile}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="px-5 py-4">
                          <form className="space-y-4">
                            <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
                              <input
                                key={inputKey}
                                type="file"
                                id="image"
                                accept="image/*"
                                className="absolute w-full h-full opacity-0 cursor-pointer"
                                onChange={handleImageChange}
                              />

                              {pimage && (
                                <div className="relative w-full h-96 ">
                                  <Cropper
                                    image={pimage}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={4 / 4}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropProfileComplete}
                                  />
                                  <button
                                    onClick={saveCroppedProfileImage}
                                    className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
                                  >
                                    Save Cropped Image
                                  </button>
                                </div>
                              )}

                              {preview ? (
                                <div className="flex flex-col items-center">
                                  <img
                                    src={preview}
                                    alt="Preview"
                                    className="mt-2 w-40 h-40 object-cover rounded-xl shadow-md border"
                                  />
                                </div>
                              ) : !pimage ? (
                                <>
                                  <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
                                    <FaCamera />
                                  </div>

                                  <span className="text-gray-500">
                                    Upload a photo
                                  </span>
                                </>
                              ) : null}
                            </div>
                            <button
                              onClick={ApplyImage}
                              className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
                            >
                              Apply Image
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                  <p className="absolute right-0 text-sm text-gray-700 mt-4 mr-6">
                    <span className="text-red-500">*</span> indicates required
                  </p>
                </div>
                <div className="py-14 px-6">
                  <form>
                    <div className="">
                      <label className="block text-gray-700 text-md font-bold ">
                        Group name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="group_name"
                        value={formData.group_name}
                        onChange={handlegroupChange}
                        placeholder="Group Name"
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                      />
                      <span className="text-red-500 text-sm">
                        {error.group_name}
                      </span>
                    </div>
                    <div className="">
                      <label className="block text-gray-700 text-md font-bold ">
                        Description <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        type="text"
                        name="description"
                        onChange={handlegroupChange}
                        value={formData.description}
                        placeholder="What is the purpose of your group?"
                        rows={4}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                      />
                      <span className="text-red-500 text-sm">
                        {error.description}
                      </span>
                    </div>
                    <div className="mb-4">
                      <label className="block text-gray-700 text-md font-bold ">
                        Industry(up to 3)
                      </label>
                      <Box className="w-full">
                        <Autocomplete
                          multiple
                          options={industries}
                          getOptionLabel={(option) => option.industry_name}
                          value={formData.industry}
                          onChange={(event, newValue) => {
                            if (newValue.length <= 3) {
                              setFormData({ ...formData, industry: newValue });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select or type industry"
                            />
                          )}
                          renderTags={() => null}
                        />
                      </Box>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {formData.industry.map((industry, index) => (
                          <Chip
                            key={index}
                            label={industry.industry_name}
                            onDelete={() =>
                              setFormData({
                                ...formData,
                                industry: formData.industry.filter(
                                  (i) => i !== industry
                                ),
                              })
                            }
                          />
                        ))}
                      </div>

                      <span className="text-red-500 text-sm">
                        {error.industry}
                      </span>
                    </div>

                    <div className="">
                      <label className="block text-gray-700 text-md font-bold ">
                        Location
                      </label>
                      <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handlegroupChange}
                        placeholder="Add a Location to your group"
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                      />
                      <span className="text-red-500 text-sm">
                        {error.location}
                      </span>
                    </div>

                    <div className="">
                      <label className="block text-gray-700 text-md font-bold ">
                        Rules
                      </label>
                      <textarea
                        type="text"
                        name="rules"
                        value={formData.rules}
                        onChange={handlegroupChange}
                        placeholder="Set the tone and expectation of your group"
                        rows={4}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                      />
                      <span className="text-red-500 text-sm">
                        {error.rules}
                      </span>
                    </div>
                    <div className="flex flex-col mb-4">
                      <label className="block text-gray-700 text-md font-bold mb-2">
                        Group type
                      </label>
                      <FormControl>
                        <RadioGroup
                          value={formData.group_type}
                          onChange={handleradiochange}
                          aria-labelledby="demo-customized-radios"
                          name="customized-radios"
                        >
                          <FormControlLabel
                            value="Public"
                            control={<BpRadio />}
                            label={
                              <div>
                                <span className="text-sm font-medium">
                                  Public
                                </span>
                                <p className="text-sm text-gray-500">
                                  Anyone, on or off LinkedIn can see posts in
                                  the group. The group appears in search results
                                  and is visible to others on members’ profiles.
                                </p>
                              </div>
                            }
                            className="w-full mb-2"
                          />

                          <FormControlLabel
                            value="Private"
                            control={<BpRadio />}
                            label={
                              <div className="flex flex-col">
                                <span className="text-sm font-medium">
                                  Private
                                </span>
                                <p className="text-sm text-gray-500">
                                  Only group members can see posts in the group.
                                </p>
                              </div>
                            }
                            className="w-full mb-2"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>

                    <div className="mb-4">
                      <label className="block text-gray-700 text-md font-bold mb-2 ">
                        Discoverability
                      </label>
                      {formData.group_type === "Public" ? (
                        <p className="text-sm text-gray-500">
                          Public groups appear in search results and are visible
                          to others on members’ profiles.
                        </p>
                      ) : (
                        <FormControl>
                          <RadioGroup
                            value={formData.discoverability}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                discoverability: e.target.value,
                              }))
                            }
                            aria-labelledby="discoverability-radios"
                            name="discoverability-radios"
                          >
                            <FormControlLabel
                              value="Listed"
                              control={<BpRadio />}
                              label={
                                <div>
                                  <span className="text-sm font-medium">
                                    Listed
                                  </span>
                                  <p className="text-sm text-gray-500">
                                    The group appears in search results, is
                                    visible to others on members’ profiles, and
                                    LinkedIn users can see whether a connection
                                    is a member.
                                  </p>
                                </div>
                              }
                              className="w-full mb-2"
                            />

                            <FormControlLabel
                              value="Unlisted"
                              control={<BpRadio />}
                              label={
                                <div className="flex flex-col">
                                  <span className="text-sm font-medium">
                                    Unlisted
                                  </span>
                                  <p className="text-sm text-gray-500">
                                    The group does not appear in search results
                                    for non-group members and is not visible to
                                    non-group members on members’ profiles.
                                  </p>
                                </div>
                              }
                              className="w-full mb-2"
                            />
                          </RadioGroup>
                        </FormControl>
                      )}
                    </div>
                    <div className="mb-4">
                      <label className="block text-gray-700 text-md font-bold mb-2">
                        Permissions
                      </label>

                      <div className="flex flex-col gap-2">
                        <label className="flex items-start gap-3">
                          <input
                            type="checkbox"
                            className="appearance-none !w-6 !h-6 border-2 border-gray-400 rounded-md checked:bg-green-600 checked:border-green-600 checked:after:content-['✔'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:leading-6 checked:after:text-lg"
                            onChange={() =>
                              handleCheckboxChange("allow_invite")
                            }
                            checked={formData.allow_invite}
                          />
                          <div className="max-w-[550px]">
                            <span className="text-black font-medium text-md">
                              Allow members to invite their connections
                            </span>
                            <p className="text-gray-500 text-sm mt-1">
                              Group members can invite 1st degree connections to
                              the group. All requests to join will still require
                              admin approval.
                            </p>
                          </div>
                        </label>

                        <label className="flex items-start gap-3">
                          <input
                            type="checkbox"
                            className="appearance-none !w-6 !h-6 border-2 border-gray-400 rounded-md checked:bg-green-600 checked:border-green-600 checked:after:content-['✔'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:leading-6 checked:after:text-lg"
                            onChange={() =>
                              handleCheckboxChange("admin_approve")
                            }
                            checked={formData.admin_approve}
                          />
                          <div className="max-w-[550px]">
                            <span className="text-black font-medium text-md">
                              Require new posts to be reviewed by admins
                            </span>
                            <p className="text-gray-500 text-sm mt-1">
                              Members’ posts will require admin approval within
                              14 days before they become visible to others.
                            </p>
                          </div>
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="border-t">
                <div className="flex justify-between space-x-2  py-4 px-6">
                  <button className="bg-blue-500 text-white px-4 py-1 rounded-2xl">
                    Delete group
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-1 rounded-2xl"
                    onClick={handleeditgroup}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditGroupModal;
